import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@views/home/Index.vue";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const routerBase =
  process.env.NODE_ENV === "development"
    ? "/"
    : process.env.VUE_APP_BASE_URL || "/";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/list",
    name: "List",
    component: () => import("../views/ListPage.vue"),
  },
  {
    path: "/detail",
    name: "Detail",
    component: () => import("../views/DetailPage.vue"),
  },
  {
    path: "/terms",
    name: "Terms",
    component: () => import("../views/TermsPage.vue"),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: routerBase,
  routes,
});

export default router;
